import { CartErrorEvent, CartLinesUpdateEvent } from '@shopify/events';

/* GN — Componi il tuo pack: aggiunta con un tap + contatore per tipo prodotto. */
const DONE_MS = 1500;
const UPDATE_EVENT = CartLinesUpdateEvent.eventName || 'shopify:cart:lines-update';
const routes = () => window.Theme?.routes || {};

class GnStickerPack extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    this.generation = 0;
    const { signal } = this.abort;
    this.addEventListener('click', (event) => this.onClick(event), { signal });
    document.addEventListener(UPDATE_EVENT, (event) => this.onCartUpdate(event), { signal });
  }

  disconnectedCallback() {
    this.generation += 1;
    this.abort?.abort();
  }

  get countEl() { return this.querySelector('[data-gn-sp-count]'); }

  say(message) {
    const live = this.querySelector('[data-gn-sp-live]');
    if (live) live.textContent = message;
  }

  async onClick(event) {
    const button = event.target.closest('[data-gn-sp-add]');
    if (!button || !this.contains(button) || button.dataset.state === 'busy') return;
    event.preventDefault();
    const id = button.dataset.variantId;
    const name = button.getAttribute('aria-label')?.replace(/^Aggiungi | al pack$/g, '') || 'Sticker';
    button.dataset.state = 'busy';
    button.setAttribute('aria-busy', 'true');

    const deferred = CartLinesUpdateEvent.createPromise();
    this.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add', context: 'product', lines: [{ merchandiseId: String(id), quantity: 1 }],
      promise: deferred.promise, detail: { source: 'gn-sticker-pack' },
    }));

    try {
      const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')]
        .map((el) => el.dataset.sectionId).filter(Boolean))];
      const body = new FormData();
      body.append('id', String(id));
      body.append('quantity', '1');
      if (sections.length) body.append('sections', sections.join(','));
      body.append('sections_url', window.location.pathname);
      const response = await fetch(routes().cart_add_url || '/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body });
      const result = await response.json();
      if (!response.ok || result.status || result.errors) throw new Error(result.description || result.message || 'Unable to add item');
      let cart = null;
      try {
        const cartResponse = await fetch(`${routes().cart_url || '/cart'}.js`, { headers: { Accept: 'application/json' } });
        if (cartResponse.ok) cart = await cartResponse.json();
      } catch { /* aggiunta riuscita: il drawer usa comunque le sezioni restituite */ }
      deferred.resolve({
        cart: cart ? CartLinesUpdateEvent.createCartFromAjaxResponse({ ...cart, sections: result.sections }) : null,
        detail: { sections: result.sections, items: result.items, source: 'gn-sticker-pack', didError: false, refreshFailed: !cart },
      });
      if (cart) this.renderCount(cart);
      button.dataset.state = 'done';
      this.say(`${name} aggiunto al pack.`);
    } catch (error) {
      deferred.reject(error);
      document.dispatchEvent(new CartErrorEvent({ error: error.message, code: 'INVALID', detail: { source: 'gn-sticker-pack' } }));
      button.dataset.state = 'error';
      this.say(`Non è stato possibile aggiungere ${name}. Riprova.`);
    } finally {
      button.removeAttribute('aria-busy');
      window.setTimeout(() => { if (button.isConnected) button.dataset.state = 'idle'; }, DONE_MS);
    }
  }

  // Ascolta tutti gli aggiornamenti carrello (pulsante principale, drawer, altre sezioni).
  // ponytail: sempre una GET /cart.js dopo l'evento; il cart dell'evento non garantisce product_type.
  async onCartUpdate(event) {
    // l'elemento che ha emesso l'evento aggiorna già il proprio contatore in onClick
    if (!this.countEl || !event?.promise || event.target === this) return;
    const generation = ++this.generation;
    try { await event.promise; } catch { return; }
    try {
      const response = await fetch(`${routes().cart_url || '/cart'}.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      if (this.isConnected && generation === this.generation) this.renderCount(cart);
    } catch { /* una lettura fallita non deve trasformare un'aggiunta riuscita in errore */ }
  }

  renderCount(cart) {
    const el = this.countEl;
    if (!el) return;
    const type = this.dataset.productType;
    const next = cart.items.filter((item) => item.product_type === type).reduce((n, item) => n + item.quantity, 0);
    if (String(next) === el.textContent.trim()) return;
    el.textContent = String(next);
    const pill = el.closest('.gn-sp-count');
    pill?.classList.remove('is-pop');
    void pill?.offsetWidth;
    pill?.classList.add('is-pop');
  }
}

if (!customElements.get('gn-sticker-pack')) customElements.define('gn-sticker-pack', GnStickerPack);
